import React from 'react';
import SVGImage from '../layout/SVGImage';

interface OperationManagementPowerPlantRegistrationModalExcelItemProps {
  testId?: string;
  className?: string;
  text?: string;
}

export const OperationManagementPowerPlantRegistrationModalExcelItem: React.FC<
  OperationManagementPowerPlantRegistrationModalExcelItemProps
> = ({ testId, className, text }) => {
  return (
    <div
      data-testid={testId}
      className={`flex h-[42px] items-center rounded-[7px] bg-white py-[10px] pr-5 ${className}`}
    >
      <span className="noto-13-normal ml-[42px] leading-[23px] text-dark-10">
        {text}
      </span>
      <SVGImage name="excel-second" className="ml-auto" />
      <SVGImage name="close" className="ml-[14px] cursor-pointer" />
    </div>
  );
};
